import _regeneratorRuntime from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _this = this;

import * as tslib_1 from "tslib";
import { encode } from '../jsonEncode';
import { BaseApiUrl, LoginApiUrl, UIClientTypes } from '@tradingblock/types';
import { LogoutTokenUrl, NoPassLoginFinishUrl, NoPassLoginStartUrl } from '../constants';
import { verify } from '../utilities/JwtUtilities';

function isString(x) {
  return typeof x === 'string';
}

export function TryLogin(values, options) {
  return tslib_1.__awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var host, loginUrl;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            host = options.host || '';
            loginUrl = host + (options.subdirectory ? options.subdirectory : '') + LoginApiUrl(options.subroot);
            _context.next = 4;
            return fetch(loginUrl, {
              method: 'post',
              body: JSON.stringify({
                encoded: encode(values)
              }),
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(function (res) {
              return res.json();
            }).then(function (json) {
              return json;
            });

          case 4:
            return _context.abrupt("return", _context.sent);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}
var httpOptions = {
  headers: {
    Accept: 'application/json'
  }
};
export var auth = function auth(api) {
  return {
    logout: function logout() {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", api.authenticated().post(LogoutTokenUrl, {}, httpOptions));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
  };
};

var tryVerify = function tryVerify(publicKey, token) {
  return tslib_1.__awaiter(_this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3() {
    var decoded, jwtValues;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return verify(publicKey, token, {
              clientType: UIClientTypes.dashboard,
              algorithms: ['RS256'],
              ignoreExpiration: false
            });

          case 3:
            decoded = _context3.sent;

            if (!(!decoded || isString(decoded))) {
              _context3.next = 9;
              break;
            }

            console.warn('jwt response was invalid, an object was expected', decoded);
            return _context3.abrupt("return", null);

          case 9:
            jwtValues = decoded;
            return _context3.abrupt("return", {
              value: token,
              decoded: jwtValues
            });

          case 11:
            _context3.next = 17;
            break;

          case 13:
            _context3.prev = 13;
            _context3.t0 = _context3["catch"](0);
            console.warn('token verification failed:', _context3.t0);
            return _context3.abrupt("return", null);

          case 17:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 13]]);
  }));
};

export var verifyToken = function verifyToken(id_token, uiApi) {
  return tslib_1.__awaiter(_this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4() {
    var pubKey;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return fetch("".concat(BaseApiUrl, "/publickey")).then(function (res) {
              return res.json();
            });

          case 2:
            pubKey = _context4.sent;
            _context4.next = 5;
            return tryVerify(pubKey.key, id_token);

          case 5:
            return _context4.abrupt("return", _context4.sent);

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
};
export function TryNoPassLogin(values, host, loginUrl, setImage, setRequestInProgress, setNoPassError) {
  return tslib_1.__awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5() {
    var username, password, apiToken, clientType, noPassLoginStartUrl, noPassLoginFinishUrl, data1, authId, image, data2, tokenPayload, uiTokenData, tokenResult, value, decoded;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            username = values.username, password = values.password, apiToken = values.apiToken, clientType = values.clientType;
            noPassLoginStartUrl = host + '/' + NoPassLoginStartUrl + '?username=' + values.username;
            noPassLoginFinishUrl = host + '/' + NoPassLoginFinishUrl + '?authid=';
            setRequestInProgress(true);
            _context5.prev = 4;
            _context5.next = 7;
            return fetch("".concat(noPassLoginStartUrl), {
              method: 'post',
              body: JSON.stringify({
                encoded: encode(values)
              }),
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(function (res) {
              return res.json();
            });

          case 7:
            data1 = _context5.sent;

            if (!(data1.Payload && data1.Payload.AuthId)) {
              _context5.next = 33;
              break;
            }

            authId = data1.Payload.AuthId;
            image = data1.Payload.Image;
            setImage(image);
            _context5.next = 14;
            return fetch("".concat(noPassLoginFinishUrl + authId)).then(function (res) {
              return res.json();
            });

          case 14:
            data2 = _context5.sent;
            tokenPayload = data2.Payload;

            if (!tokenPayload) {
              _context5.next = 32;
              break;
            }

            _context5.next = 19;
            return TryLogin({
              username: username,
              password: '',
              apiToken: tokenPayload,
              clientType: clientType
            }, {
              host: loginUrl
            });

          case 19:
            uiTokenData = _context5.sent;
            _context5.next = 22;
            return verifyToken(uiTokenData.token, loginUrl);

          case 22:
            tokenResult = _context5.sent;

            if (!tokenResult) {
              _context5.next = 29;
              break;
            }

            setRequestInProgress(false);
            value = tokenResult.value, decoded = tokenResult.decoded;
            return _context5.abrupt("return", Object.assign({}, decoded, {
              apiToken: tokenPayload,
              token: value
            }));

          case 29:
            setNoPassError('NoPass Authentication Failed');

          case 30:
            _context5.next = 33;
            break;

          case 32:
            setNoPassError('User is not registered or the request has been denied.');

          case 33:
            _context5.next = 39;
            break;

          case 35:
            _context5.prev = 35;
            _context5.t0 = _context5["catch"](4);
            console.error('⬤ NoPass Authentication Error', _context5.t0);
            setNoPassError("NoPass Authentication Error: ".concat(_context5.t0));

          case 39:
            setRequestInProgress(false);
            return _context5.abrupt("return", null);

          case 41:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[4, 35]]);
  }));
}